import { Injectable } from "@angular/core";
import { ID, QueryEntity } from "@datorama/akita";
import { Observable } from "rxjs";
import { IResourceItem, TResourceItemCategory } from "@common/interfaces/resourceItem";
import { ResourceItemState, ResourceItemStore } from "./resourceItem.store";

@Injectable({
  providedIn: 'root'
})
export class ResourceItemQuery extends QueryEntity<ResourceItemState> {

  constructor(protected store: ResourceItemStore) {
    super(store);
  }

  selectResourceItemsByProjectId(projectId: ID): Observable<IResourceItem[]> {
    return this.selectAll({
      filterBy: entity => entity.projectId === projectId
    })
  }

  selectResourceItemsByProjectIdAndCategory(projectId: ID, category: TResourceItemCategory): Observable<IResourceItem[]> {
    return this.selectAll({
      filterBy: [
        entity => entity.projectId === projectId,
        entity => entity.category === category
      ]
    })
  }

  selectResourceItemsByProjectIdAndCategoryAndResourceIds(projectId: ID, category: TResourceItemCategory, resourceIds: string[]): Observable<IResourceItem[]> {
    return this.selectAll({
      filterBy: [
        entity => entity.projectId === projectId,
        entity => entity.category === category,
        entity => resourceIds.includes(entity.resourceId)
      ]
    });
  }

  getResourceItemsByProjectIdAndCategory(projectId: ID, category: TResourceItemCategory): IResourceItem[] {
    return this.getAll({
      filterBy: [
        resourceItem => resourceItem.projectId === projectId,
        resourceItem => resourceItem.category === category
      ]
    });
  }

  getResourceItemsByProjectIdAndCategoryAndResourceIds(projectId: ID, category: TResourceItemCategory, resourceIds: string[]): IResourceItem[] {
    return this.getAll({
      filterBy: [
        resourceItem => resourceItem.projectId === projectId,
        resourceItem => resourceItem.category === category,
        resourceItem => resourceIds.includes(resourceItem.resourceId)
      ]
    });
  }

}
